import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type UpdateDimensionOptionPayload = {
	categoryDimensionOptionUid: string;
	sequence: number;
	isTextbox: boolean;
	localizations: {
		"en-us": string;
		"de-ch": string;
		"de-de": string;
		"fr-fr": string;
		"it-it": string;
	};
};

const updateDimensionOption = async (payload: UpdateDimensionOptionPayload): Promise<any> => { 
	const response = await apiDal.post("/categorydimensionoptions/update", payload);
	return response.data;
};

export const useUpdateDimensionOption = () => {
	return useMutation({
		mutationFn: updateDimensionOption,
	});
};
